import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
	providedIn: 'root'
})

export class SolicitacaoServicoService {

	constructor(private http: HttpClient) { }

	private authHeader(): string {
		return `Bearer ${JSON.parse(localStorage.getItem('User')).token}`;
	}

	public get() {
		let headers = new HttpHeaders();
		headers = headers.append('Authorization', this.authHeader());

		return this.http.get(`${environment.apiUrl}/cadastro/SolicitacaoServico`, { headers });
	}

	public post(body) {
		let headers = new HttpHeaders();
		headers = headers.append('Authorization', this.authHeader());

		return this.http.post(`${environment.apiUrl}/cadastro/SolicitacaoServico`, body, { headers });
	}

	public patch(body, id) {
		let headers = new HttpHeaders();
		headers = headers.append('Authorization', this.authHeader());

		return this.http.patch(`${environment.apiUrl}/cadastro/SolicitacaoServico/${id}`, body, { headers });
	}

	public delete(id) {
		let headers = new HttpHeaders();
		headers = headers.append('Authorization', this.authHeader());

		return this.http.delete(`${environment.apiUrl}/cadastro/SolicitacaoServico/${id}`, { headers });
	}
}
